import { combineReducers } from 'redux';
import { reducers as subscriptionManagerReducers } from '@yola/subscription-manager-js';
import config from './modules/config';
import user from './modules/user';
import i18n from './modules/i18n';
import sites from './modules/sites';
import dialogs from './modules/dialogs';
import error from './modules/error';
import status from './modules/status';
import products from './modules/products';
import helpCenter from './modules/help-center';

const rootReducer = () =>
  combineReducers({
    config: config.reducers.serviceConfig,
    user: combineReducers(user.reducers),
    locale: i18n.reducers.locale,
    sites: sites.reducers.sites,
    dialog: dialogs.reducers.dialog,
    criticalError: error.reducers.criticalError,
    status: status.reducers.status,
    products: combineReducers(products.reducers),
    subscriptions: combineReducers(subscriptionManagerReducers),
    helpCenter: combineReducers(helpCenter.reducers),
  });

export default rootReducer;
